import React from 'react';
import { Button, Form, Input, Typography } from 'antd';

interface LoginFormProps {
    form: any;
    loading: boolean;
    onSubmit: (data: any) => void;
    onGoBack: () => void;
    onForgotPassword?: () => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({ form, loading, onSubmit, onGoBack, onForgotPassword }) => {
    return (
        <Form form={form} layout="vertical" requiredMark={false} onFinish={onSubmit}>
            <Typography.Title level={4}>Login</Typography.Title>

            <Form.Item
                name="email"
                label="Email"
                rules={[{ type: 'email', required: true, message: 'Please insert a valid email' }]}
            >
                <Input autoComplete="username" />
            </Form.Item>

            <Form.Item name="password1" label="Password" rules={[{ required: true, message: 'Password is required' }]}>
                <Input.Password autoComplete="current-password" />
            </Form.Item>

            <Button type="primary" block size="large" htmlType="submit" loading={loading} className="mb-2">
                Login
            </Button>

            <Button block onClick={onGoBack}>
                Go Back
            </Button>

            {onForgotPassword && (
                <div className="d-flex">
                    <Button type="link" className="ml-auto p-0 m-0" onClick={onForgotPassword}>
                        Forgot your password?
                    </Button>
                </div>
            )}
        </Form>
    );
};
